import src from "IMAGE";
export default { src, width: 416, height: 70, blurWidth: 0, blurHeight: 0};
